import {HttpRequest,HttpMethod} from "./http";

class OrderProvider extends HttpRequest {

	
	GetShippingInfo(params){
		return this.request(HttpMethod.Get,`/api/v1/orders/shipping/info`,params );
	}

	CreateOrder(params){
		return this.request(HttpMethod.Post,`/api/v1/orders`,params );
	}

	ListOrder(params){
		return this.request(HttpMethod.Get,`/api/v1/orders`,params );
	}

	ListOrderDetailProduct(params){
		return this.request(HttpMethod.Get,`/api/v1/orders/detail/product`,params );
	}

	ListOrderDetail(params){
		return this.request(HttpMethod.Get,`/api/v1/orders/detail`,params );
	}

	UpdateOrder(id,params){
		return this.request(HttpMethod.Put,`/api/v1/orders/${id}`,params );
	}

	CancelOrder(id,params){
		return this.request(HttpMethod.Put,`/api/v1/orders/cancel/${id}`,params );
	}

	// Spec 2026-10-14 §3.2 #3: edit the recipient of a 111/112 order without tracking.
	updateRecipient(id,params){
		return this.request(HttpMethod.Put,`/api/v1/orders/recipient/${id}`,params );
	}

	// bo-api 099514b1 / #931: an admin stores (or, with replace:true, changes) the barcode the carrier issued but the
	// order never saved (reason barcode_not_saved). payload: { tracking_number, replace? }
	attachTracking(id,params){
		return this.request(HttpMethod.Put,`/api/v1/orders/tracking-attach/${id}`,params );
	}

	// §3.2 #4: 112 orders that belong to no packing round. params: { platform_id }
	stuckNoRound(params){
		return this.request(HttpMethod.Get,`/api/v1/orders/stuck-no-round`,params );
	}

	// §3.2 #5: 112 + no round → 111 (CAS), mirrored to App PG. payload: { order_ids }
	revertAwaitingShipment(params){
		return this.request(HttpMethod.Post,`/api/v1/orders/revert-awaiting-shipment`,params );
	}

	ChangeTrackingOrder(id,params){
		return this.request(HttpMethod.Put,`/api/v1/orders/tracking/${id}`,params );
	}
	
	ChangeShippingOrder(id,params){
		return this.request(HttpMethod.Put,`/api/v1/orders/shipping/${id}`,params );
	}

	CheckTrackingOrder(id,params){
		return this.request(HttpMethod.Post,`/api/v1/orders/trackingcheck/${id}`,params );
	}

	OrderTrackingTimeline(id){
		return this.request(HttpMethod.Get,`/api/v1/orders/${id}/tracking-timeline`);
	}

	// Lean + paginated listing for the Reprocess page. Use this instead
	// of ListOrder() so the browser doesn't get up to 2 000 full rows.
	ReprocessList(params){
		return this.request(HttpMethod.Get,`/api/v1/orders/reprocess-list`, params);
	}

	// Lean + paginated listing for the Return-in-transit (กำลังตีกลับ /
	// status 143) queue. Envelope: {items,total,page,per_page}.
	ReturnInTransitList(params){
		return this.request(HttpMethod.Get,`/api/v1/orders/return-in-transit`, params);
	}

	TrackingRefresh(id){
		return this.request(HttpMethod.Post,`/api/v1/orders/${id}/tracking-refresh`);
	}

	// #189 staging-only simulate fulfillment for MDFStore orders.
	// action: "delivered" | "failed" | "returned"
	SimulateFulfillment(id, action){
		return this.request(HttpMethod.Post,`/api/v1/orders/${id}/simulate-fulfillment`, { action });
	}

	TrackingRefreshBulk(ids){
		return this.request(HttpMethod.Post,`/api/v1/orders/tracking-refresh-bulk`, { ids });
	}

	// Batch (server-side iterate by filter). Returns the current state;
	// re-posting while a job is running yields the same state without
	// spawning a duplicate worker.
	TrackingRefreshBatchStart(filter){
		return this.request(HttpMethod.Post,`/api/v1/orders/tracking-refresh-batch`, filter);
	}

	TrackingRefreshBatchStatus(){
		return this.request(HttpMethod.Get,`/api/v1/orders/tracking-refresh-batch/status`);
	}

	// Read the cached Thaipost daily quota snapshot (used / limit /
	// when it was last updated). Cache is refreshed automatically on
	// every refresh / poll call, so this endpoint never spends quota.
	ThaipostTrackCount(){
		return this.request(HttpMethod.Get,`/api/v1/orders/thaipost/track-count`);
	}
	// DeleteOrder(id){
	// 	return this.request(HttpMethod.Delete,`/api/v1/orders/${id}`);
	// }

	// Payment Success
	OrderPaymentConfirmSetStatusToAwaitingShipment(id,params){
		return this.request(HttpMethod.Put,`/api/v1/orders/payment/confirm/success/${id}`,params );
	}

	OrderPaymentConfirmSetStatusToCancelled(id,params){
		return this.request(HttpMethod.Put,`/api/v1/orders/payment/confirm/fail/${id}`,params );
	}

	// Change Delivery Status
	ChangeDeliveryStatus(id,params){
		return this.request(HttpMethod.Put,`/api/v1/orders/${id}/delivery`,params );
	}

	// Change Packing Status
	ChangePackingStatus(id,params){
		return this.request(HttpMethod.Put,`/api/v1/orders/${id}/packing`,params );
	}

	// Change Order Status
	ChangeOrderStatus(id,params){
		return this.request(HttpMethod.Put,`/api/v1/orders/${id}/status`,params );
	}

	ListPaymentChannel(params){
		return this.request(HttpMethod.Get,`/api/v1/paymentmethod`,params );
	}

	ListSaleChannel(params){
		return this.request(HttpMethod.Get,`/api/v1/salechannel`,params );
	}

	ListFullAddress(params){
		return this.request(HttpMethod.Get,`/api/v1/address`,params );
	}

	ListFullAddressV2(params){
		return this.request(HttpMethod.Get,`/api/v2/address`,params );
	}

	ListProduct(params){
		return this.request(HttpMethod.Get,`/api/v1/products`,params );
	}

	SyncPlatformOrder(params){
		return this.request(HttpMethod.Post,`/api/v2/platform/orders/sync`,params );
	}

	OrderReturn(params){
		return this.request(HttpMethod.Post,`/api/v2/orders/return`,params );
	}

	ReturnVideo(params){
		return this.request(HttpMethod.Post,`/api/v2/orders/return/vdo`,params );
	}

	ShippingVideo(params){
		return this.request(HttpMethod.Post,`/api/v2/orders/shipping/vdo`,params );
	}

	// mirakl Dev-B2 — Makro PRO (Mirakl) order actions, companion of bo-api #375.
	// User-triggered (NOT background-gated). Endpoints under /api/platform/mirakl/*.
	miraklSyncOrders(params){
		// POST /api/platform/mirakl/orders/sync  body {time_from?, time_to?} -> {job_id, status}
		return this.request(HttpMethod.Post,`/api/platform/mirakl/orders/sync`, params || {} );
	}

	miraklAcceptOrder(id){
		// POST /api/platform/mirakl/orders/:id/accept  (:id = bo_orders.id); empty body = accept whole order
		return this.request(HttpMethod.Post,`/api/platform/mirakl/orders/${id}/accept`, {} );
	}

	miraklShipOrder(id, params){
		// POST /api/platform/mirakl/orders/:id/ship  body {tracking_number, carrier_code?/carrier_name?+carrier_url?}
		return this.request(HttpMethod.Post,`/api/platform/mirakl/orders/${id}/ship`, params || {} );
	}
}

export default OrderProvider